import comp from "./DatasetTaggingBodyWrapper";
export default comp;
